// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__ZBR9h","loader":"Loader_loader__VBQ5R","spin":"Loader_spin__KXCYc"};